module.exports = __webpack_public_path__ + "img/rect51522.ea021776.png";